export default __webpack_public_path__ + "static/media/icare_card.e8ed1444.png";